<template>
    <el-drawer
        title="跳过人脸验证"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        :show-close="false"
    >
        <div class="drawer-content">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                size="mini"
            >
                <el-form-item prop="documentName" label="用户姓名:">
                    {{formData.documentName}}
                </el-form-item>
                <el-form-item prop="documentNumber" label="用户身份证号:">
                    <!-- <el-input placeholder="请输入用户身份证号" v-model="formData.documentNumber"></el-input> -->
                    {{formData.documentNumber}}
                </el-form-item>
            </el-form>
            <div class="MT30">
                <el-alert type="warning" title="跳过前请确认：" :closable="false">
                    <div>1、当前用户是由于个人身份信息问题始终无法通过公安库人脸验证。</div>
                    <div>2、跳过后，该用户此后在当前设备上均不会再邀请人脸验证。更换设备或者重装应用还会有人脸验证。</div>
                </el-alert>
            </div>
        </div>
        <div class="drawer-footer">
            <el-button v-if="!btnLoading" @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading" :disabled="time > 0"
                >确认跳过 {{ time > 0 ? `(${time}S)` : ''}} </el-button
            >
        </div>
    </el-drawer>
</template>

<script>

const defaultFormData = {
    documentNumber: "",
    documentName: ""
}
export default {
    data(){
        return{
            drawerShow: false,
            btnLoading:false,
            formData:{...defaultFormData},
            rules:{
                // documentNumber: [{ required: true, message: "请输入用户身份证号" }],
            },
            time: 5,
            timer: null
        }
    },
    methods:{
        close() {
            this.formData = {...defaultFormData};
            this.$refs['formData'].clearValidate();
            // this.$refs['formData'].resetFields();

            this.time = 5;
            clearInterval(this.timer);

            this.drawerShow = false;
        },
        show(data) {
            this.formData = {
                documentNumber: data.documentNumber,
                documentName: data.documentName
            }
            this.drawerShow = true;

            this.timer = setInterval(() => {
                if( this.time > 0 ){
                    this.time --;
                }else{
                    clearInterval(this.timer);
                }
            },1000)
        },
        // 表单提交
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.submitAction()
                } else {
                    return false;
                }
            });
        },
        submitAction(){
            const _url = "/commonPerformer/skipFaceAuth";
            this.btnLoading = true;
            this.$request({
                url: _url,
                params: {
                    queryValue: this.formData.documentNumber
                },
                method: "post",
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state && state == 1) {
                        this.$alert(msg || '跳过成功，请联系用户刷新"票夹页"查看处理结果' , "成功", {
                            type: "success",
                            center: true,
                            callback: () => {
                                this.$emit('onUpdate');
                                this.close();
                            }
                        })
                    }else if ( state && state == 'reset.error') {
                        const _msg = '<div style="text-align:left"><div>已为用户跳过最近登录设备上的人脸验证。请勿重复操作！</div>\
                            <div>注：若用户反馈仍然看不到入场码，按如下流程操作：</div>\
                            <div>1.重置当前用户人脸验证次数，让用户在最近使用的设备上尝试刷脸。</div>\
                            <div>2.如果重置后用户人脸验证依旧不通过，再操作【跳过人脸验证】功能。</div></div>';
						this.$alert( _msg , "失败", {
                            type: "error",
                            center: true,
                            dangerouslyUseHTMLString: true
                        })
						
					}
					 else {
                        this.$alert(msg || "操作失败,请重试" , "失败", {
                            type: "error",
                            center: true
                        })
                    }
                })
                .catch(() => {
                    this.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    this.btnLoading = false;
                });   
        }
    }
}
</script>
